import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TreatmentsScreen } from "../components/treatments/TreatmentsScreen";

// `view` (not `status`) — the /clients route already uses `status` for
// client lifecycle (prospect/member/lapsed/flagged) and TanStack Router
// unifies search-param types across the route tree.
const searchSchema = z.object({
  view: z.enum(["active", "archived"]).default("active"),
});

export const Route = createFileRoute("/_auth/treatments")({
  staticData: {
    titleKey: "treatments.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 5,
  },
  validateSearch: searchSchema,
  component: TreatmentsRoute,
});

function TreatmentsRoute() {
  const { view } = Route.useSearch();
  return <TreatmentsScreen status={view} />;
}
